import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pdf-preview-molecule" }
const _hoisted_2 = { class: "tags-container" }
const _hoisted_3 = { class: "pdf-content" }
const _hoisted_4 = {
  key: 0,
  class: "pdf-loading"
}
const _hoisted_5 = {
  key: 1,
  class: "pdf-error"
}
const _hoisted_6 = {
  key: 2,
  class: "pdf-placeholder"
}
const _hoisted_7 = {
  key: 3,
  class: "pdf-viewer"
}
const _hoisted_8 = { class: "pdf-viewer-placeholder" }
const _hoisted_9 = { class: "pdf-filename" }
const _hoisted_10 = { class: "pdf-controls" }
const _hoisted_11 = { class: "page-info" }

import { ref, onMounted, onUnmounted } from 'vue';
  import ButtonAtom from '@/components/atoms/ButtonAtom.vue';
  import IconAtom from '@/components/atoms/IconAtom.vue';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'PdfPreviewMolecule',
  props: {
    previewData: {},
    coverImage: {}
  },
  setup(__props: any) {

  const props = __props;

  const pdfContainer = ref<HTMLDivElement | null>(null);
  const currentPage = ref(1);
  const totalPages = ref(0);
  const isLoading = ref(true);
  const pdfError = ref(false);
  const pdfUrl = ref<string>('');

  onMounted(async () => {
    if (props.previewData.url_path) {
      await loadPdf();
    }
  });

  onUnmounted(() => {
    if (pdfUrl.value) {
      URL.revokeObjectURL(pdfUrl.value);
    }
  });

  const loadPdf = async () => {
    try {
      isLoading.value = true;
      pdfError.value = false;

      if (typeof props.previewData.url_path === 'object') {
        // It's a file object
        pdfUrl.value = URL.createObjectURL(props.previewData.url_path);
      } else {
        // It's a URL string
        pdfUrl.value = props.previewData.url_path;
      }

      // For preview, we'll show a placeholder since PDF.js requires additional setup
      // In production, you would integrate PDF.js here
      totalPages.value = 1; // Placeholder
      isLoading.value = false;
    } catch (error) {
      console.error('Error loading PDF:', error);
      pdfError.value = true;
      isLoading.value = false;
    }
  };

  const nextPage = () => {
    if (currentPage.value < totalPages.value) {
      currentPage.value++;
    }
  };

  const prevPage = () => {
    if (currentPage.value > 1) {
      currentPage.value--;
    }
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "preview-title" }, "E-book Preview", -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "preview-header",
        style: _normalizeStyle({
          backgroundImage: `url(${props.coverImage})`,
        })
      }, [
        _createElementVNode("h1", null, _toDisplayString(props.previewData.resource_name), 1),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.previewData.tags, (tag) => {
            return (_openBlock(), _createBlock(ButtonAtom, {
              key: tag.id,
              class: "btn btn-secondary tag-button",
              disabled: false
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(tag.value), 1)
              ]),
              _: 2
            }, 1024))
          }), 128)),
          _createVNode(ButtonAtom, {
            class: "btn btn-primary ebook-tag",
            disabled: false
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode(" 📚 E-book ")
            ])),
            _: 1
          })
        ])
      ], 4),
      _createElementVNode("div", _hoisted_3, [
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[1] || (_cache[1] = [
              _createElementVNode("p", null, "Loading PDF...", -1)
            ])))
          : (pdfError.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(IconAtom, { icon: "closeIcon" }),
                _cache[2] || (_cache[2] = _createElementVNode("p", null, "Error loading PDF file", -1))
              ]))
            : (!props.previewData.url_path)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(IconAtom, { icon: "bookIcon" }),
                  _cache[3] || (_cache[3] = _createElementVNode("p", null, "Upload a PDF file to see preview", -1))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(IconAtom, { icon: "bookIcon" }),
                    _createElementVNode("p", _hoisted_9, _toDisplayString(typeof props.previewData.url_path === 'object'
                  ? props.previewData.url_path.name
                  : 'PDF Document'), 1),
                    _cache[4] || (_cache[4] = _createElementVNode("p", { class: "pdf-info" }, "PDF viewer will display here", -1)),
                    _cache[5] || (_cache[5] = _createElementVNode("p", { class: "pdf-note" }, [
                      _createElementVNode("strong", null, "Note:"),
                      _createTextVNode(" Full PDF viewer with pagination will be implemented in the app ")
                    ], -1))
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(ButtonAtom, {
                      class: "btn btn-secondary",
                      onClick: prevPage,
                      disabled: currentPage.value <= 1
                    }, {
                      default: _withCtx(() => [
                        _createVNode(IconAtom, { icon: "angleLeft" }),
                        _cache[6] || (_cache[6] = _createTextVNode(" Previous "))
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createElementVNode("span", _hoisted_11, " Page " + _toDisplayString(currentPage.value) + " of " + _toDisplayString(totalPages.value), 1),
                    _createVNode(ButtonAtom, {
                      class: "btn btn-secondary",
                      onClick: nextPage,
                      disabled: currentPage.value >= totalPages.value
                    }, {
                      default: _withCtx(() => [
                        _cache[7] || (_cache[7] = _createTextVNode(" Next ")),
                        _createVNode(IconAtom, { icon: "angleRight" })
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ])
                ]))
      ])
    ])
  ]))
}
}

})